import React, { FC, useEffect, useState } from "react";
import { UserPage } from '../components/UserPage';
import { Section } from "../components/Section";
import QrReader from 'react-qr-reader';

export const QrCode: FC = () => {
    const [data, setData] = useState("");
    const [done, setDone] = useState(false);

    useEffect(() => {
        let tid: any;
        if (done) {
            tid = setTimeout(() => {
                window.location.href = data;
            }, 2000);
        }
        return () => {
            clearTimeout(tid);
        }
    }, [done]);

    const handleOnError = (error: any) => {
        console.error(error);
    };

    const handleOnScan = (data: string | null) => {
        if (data === null) {
            return;
        }
        setData(data);
        setDone(true);
    };

    return (
        <UserPage title="Salon.jp | QRリーダー">
            <Section fillOnSp={true}>
                <div className="wrap">
                    <div className="qr-reader-container">
                        {data === "" && (
                            <QrReader
                                delay={300}
                                onError={handleOnError}
                                onScan={handleOnScan}
                            />
                        )}
                    </div>
                </div>
            </Section>

            <style jsx>{`
                .wrap {
                    min-height: 50vh;
                    padding: 1rem;
                }
                .qr-reader-container {
                    width: 100%;
                }
                @media screen and (max-width: 570px) {
                    .wrap {
                        height: calc(${window.innerHeight}px - 45px - 45px);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .qr-reader-container {
                        margin-bottom: 50px;
                    }
                }
            `}</style>
        </UserPage>
    );
};
